import { gql } from '@apollo/client';
import type { ApplyGroupRecommendationInput, GroupRecommendation } from '../../__generated__/graphql';
import graphQLRequester from '../../request/GraphQLRequester';

const throwOnErrors = <T extends { errors?: Array<{ message: string }> }>(result: T): T => {
  if (result.errors?.length) {
    throw new Error(`GraphQL mutation errors: ${result.errors.map((e) => e.message).join(', ')}`);
  }
  return result;
};

export class GraphQLGroupRecommendationsRequester {
  public generateGroupRecommendations = (fleetId: string): Promise<GroupRecommendation[]> => {
    return graphQLRequester
      .mutate<{ generateGroupRecommendation: GroupRecommendation[]; errors: Array<any> }>({
        mutation: gql`
          mutation GenerateGroupRecommendation($fleetId: ID!) {
            generateGroupRecommendation(fleetId: $fleetId) {
              id
              fleetId
              suggestedName
              vehicleIds
              reason
              dismissCount
              appliedPayloadJson
            }
          }
        `,
        variables: { fleetId },
      })
      .then((result) => throwOnErrors(result).generateGroupRecommendation);
  };

  public applyGroupRecommendation = (fleetId: string, id: string, input: ApplyGroupRecommendationInput): Promise<GroupRecommendation> => {
    return graphQLRequester
      .mutate<{ applyGroupRecommendation: GroupRecommendation; errors: Array<any> }>({
        mutation: gql`
          mutation ApplyGroupRecommendation($fleetId: ID!, $id: ID!, $input: ApplyGroupRecommendationInput!) {
            applyGroupRecommendation(fleetId: $fleetId, id: $id, input: $input) {
              id
              fleetId
              suggestedName
              vehicleIds
              reason
              dismissCount
              appliedPayloadJson
            }
          }
        `,
        variables: { fleetId, id, input },
      })
      .then((result) => throwOnErrors(result).applyGroupRecommendation);
  };

  public dismissGroupRecommendation = (fleetId: string, id: string): Promise<GroupRecommendation> => {
    return graphQLRequester
      .mutate<{ dismissGroupRecommendation: GroupRecommendation; errors: Array<any> }>({
        mutation: gql`
          mutation DismissGroupRecommendation($fleetId: ID!, $id: ID!) {
            dismissGroupRecommendation(fleetId: $fleetId, id: $id) {
              id
              fleetId
              suggestedName
              vehicleIds
              reason
              dismissCount
              appliedPayloadJson
            }
          }
        `,
        variables: { fleetId, id },
      })
      .then((result) => throwOnErrors(result).dismissGroupRecommendation);
  };
}

export default GraphQLGroupRecommendationsRequester;
